import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import deLang from './locales/de.json';
import enLang from './locales/en-GB.json';
import esLang from './locales/es.json';
import frLang from './locales/fr.json';
import itLang from './locales/it.json';
import jaLang from './locales/ja.json';

const resources = {
  'en-GB': {
    translation: enLang,
  },
  fr: {
    translation: frLang,
  },
  de: {
    translation: deLang,
  },
  it: {
    translation: itLang,
  },
  es: {
    translation: esLang,
  },
  ja: {
    translation: jaLang,
  },
};
i18n.use(initReactI18next).init({
  resources,
  supportedLngs: ['en-GB', 'fr', 'de', 'it', 'es', 'ja'],
  lng: 'en-GB',
  fallbackLng: 'en-GB',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
